import React from "react";
import { NavLink } from "react-router-dom";

export default function MobileBottomNav({ navItems = [] }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white px-2 py-2 shadow-2xl md:hidden">
      <div className="mx-auto grid max-w-2xl grid-cols-5 gap-1">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "flex min-w-0 flex-col items-center gap-1 rounded-2xl px-1 py-2 text-[10px] font-extrabold transition",
                  isActive ? "bg-brand-700 text-white" : "text-slate-500 hover:bg-slate-100",
                ].join(" ")
              }
            >
              <Icon className="h-5 w-5" />
              <span className="truncate">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}